import SequenceAlignmentTabOptionsView from 'analyses/alignment/SequenceAlignmentTabOptionsView';
import AnnotationsTableTabState from 'analyses/AnnotationsTableTabState';
import {AnnotationsTableTabView} from 'analyses/AnnotationsTableView';
import DigestTabState from 'analyses/DigestTabState';
// @ts-expect-error
import * as DigestView from 'analyses/DigestView';
import EditPrimerTabState from 'analyses/EditPrimerTabState';
import * as EditPrimerView from 'analyses/EditPrimerView';
import Primer3TabState from 'analyses/Primer3TabState';
import * as Primer3View from 'analyses/Primer3View';
import * as PrimerWizardTab from 'analyses/primers/PrimerWizardTab';
import PrimerWizardTabState from 'analyses/primers/PrimerWizardTabState';
import SecondaryStructureTabState from 'analyses/SecondaryStructureTabState';
// @ts-expect-error
import * as SecondaryStructureView from 'analyses/SecondaryStructureView';
import TranslationTabState from 'analyses/TranslationTabState';
import {TranslationTabView} from 'analyses/TranslationView';
import VirtualDigestTabState from 'analyses/VirtualDigestTabState';
// @ts-expect-error
import * as VirtualDigestView from 'analyses/VirtualDigestView';
import AnalysisTabState from 'analysis-tool/backbone/AnalysisTabState';
import AnalysisTabView from 'analysis-tool/backbone/AnalysisTabView';
import AnalysisTemplateTabState from 'analysis-tool/templates/AnalysisTemplateTabState';
import AnalysisTemplateTabView from 'analysis-tool/templates/AnalysisTemplateTabView';
import AntibodyMapTabOptionsView from 'antibodies/antibody-map/AntibodyMapTabOptionsView';
import AntibodyMapTabState from 'antibodies/antibody-map/AntibodyMapTabState';
import AntibodyMapTabView from 'antibodies/antibody-map/AntibodyMapTabView';
import JellyfishTabState from 'app-core/archetype/workspace/JellyfishTabState';
import JellyfishTabView from 'app-core/archetype/workspace/JellyfishTabView';
import GibsonTabState from 'assembly/tabs/GibsonTabState';
import * as GibsonTabView from 'assembly/tabs/GibsonTabView';
import GoldenGateTabState from 'assembly/tabs/GoldenGateTabState';
import * as GoldenGateTabView from 'assembly/tabs/GoldenGateTabView';
import BenchlingAppTabState from 'benchling-apps/backbone/BenchlingAppTabState';
import BenchlingAppTabView from 'benchling-apps/backbone/BenchlingAppTabView';
import {BufferViewMetadata, BufferViewType} from 'buffers/BufferTypes';
import MoleculeChemicalStructureTabState from 'chemistry/molecules/tabs/MoleculeChemicalStructureTabState';
import MoleculeChemicalStructureTabView from 'chemistry/molecules/tabs/MoleculeChemicalStructureTabView';
import MoleculePhysicochemicalPropertiesTabState from 'chemistry/molecules/tabs/MoleculePhysicochemicalPropertiesTabState';
import MoleculePhysicochemicalPropertiesTabView from 'chemistry/molecules/tabs/MoleculePhysicochemicalPropertiesTabView';
import DatasetTabState from 'data-frames/workspace/DatasetTabState';
import DatasetTabView from 'data-frames/workspace/DatasetTabView';
import {
  ExternalFileOptionsView,
  ExternalFileTabState,
  ExternalFileTabView,
  // @ts-expect-error
} from 'external-files/ExternalFileTab';
import FileTabState from 'files/workspace/FileTabState';
import FileTabView from 'files/workspace/FileTabView';
import FormDefinitionTabState from 'forms/form-definition/FormDefinitionTabState';
import FormDefinitionTabView from 'forms/form-definition/FormDefinitionTabView';
import AnalyticsDashboardTabState from 'insights/analytics-dashboards/backbone/AnalyticsDashboardTabState';
import AnalyticsDashboardTabView from 'insights/analytics-dashboards/backbone/AnalyticsDashboardTabView';
import EmbeddedAnalyticsDashboardTabState from 'insights/embeddings/backbone/EmbeddedAnalyticsDashboardTabState';
import EmbeddedAnalyticsDashboardTabView from 'insights/embeddings/backbone/EmbeddedAnalyticsDashboardTabView';
import ConnectionDataTabState from 'instruments/connections/connection-editor/ConnectionDataTabState';
import ConnectionDataTabView from 'instruments/connections/connection-editor/ConnectionDataTabView';
import ConnectionDetailsTabState from 'instruments/connections/connection-editor/ConnectionDetailsTabState';
import ConnectionDetailsTabView from 'instruments/connections/connection-editor/ConnectionDetailsTabView';
import ConnectionRunsTabState from 'instruments/connections/connection-editor/ConnectionRunsTabState';
import ConnectionRunsTabView from 'instruments/connections/connection-editor/ConnectionRunsTabView';
import MetadataTabState from 'metadata/MetadataTabState';
import MetadataTabView from 'metadata/MetadataTabView';
import ComplexPolymerComponentsTabState from 'modbio/complex-polymers/tabs/ComplexPolymerComponentsTabState';
import ComplexPolymerComponentsTabView from 'modbio/complex-polymers/tabs/ComplexPolymerComponentsTabView';
import ComplexPolymerMapTabState from 'modbio/complex-polymers/tabs/ComplexPolymerMapTabState';
import ComplexPolymerMapTabView from 'modbio/complex-polymers/tabs/ComplexPolymerMapTabView';
import GenerativeModelsTabState from 'model-hub/generative-models/GenerativeModelsTabState';
import GenerativeModelsTabView from 'model-hub/generative-models/GenerativeModelsTabView';
import ProteinAlignmentTabOptionsView from 'molbio/aa-sequences/alignments/AaSequenceAlignmentTabOptionsView';
import AlphaFoldOptionsView, {
  AlphaFoldOptionsProps,
} from 'molbio/aa-sequences/alphafold/AlphaFoldOptionsView';
import AlphaFoldTabState from 'molbio/aa-sequences/alphafold/AlphaFoldTabState';
import AlphaFoldTabView, {AlphaFoldTabContentProps} from 'molbio/aa-sequences/alphafold/AlphaFoldTabView';
import {
  BiochemicalPropertiesTabView,
  ProteinBiochemicalPropertiesTabState,
  TranslationBiochemicalPropertiesTabState,
} from 'molbio/aa-sequences/BiochemicalPropertiesTab';
import * as ProteinComplexPreviewTab from 'molbio/aa-sequences/complex/AaSequenceComplexPreviewTab';
import * as ProteinComplexPropertiesTab from 'molbio/aa-sequences/complex/AaSequenceComplexPropertiesTab';
import BulkAssemblyConstructsTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyConstructsTabState';
import BulkAssemblyConstructsTabView from 'molbio/bulk-assembly/backbone/BulkAssemblyConstructsTabView';
import BulkAssemblyFragmentsTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyFragmentsTabState';
import BulkAssemblyFragmentsTabView from 'molbio/bulk-assembly/backbone/BulkAssemblyFragmentsTabView';
import BulkAssemblyOverviewTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyOverviewTabState';
import BulkAssemblyOverviewTabView from 'molbio/bulk-assembly/backbone/BulkAssemblyOverviewTabView';
import CodonOptimizationTabState from 'molbio/codon-optimization/CodonOptimizationTabState';
import CodonOptimizationTabView from 'molbio/codon-optimization/CodonOptimizationTabView';
import CRISPRAssemblyTabState from 'molbio/crispr/assembly/CRISPRAssemblyTabState';
import {CRISPRAssemblyOptionsView, CRISPRAssemblyTabView} from 'molbio/crispr/assembly/CRISPRAssemblyTabView';
import CRISPRAnalysisTabState from 'molbio/crispr/CRISPRAnalysisTabState';
import {CRISPRAnalysisOptionsView, CRISPRAnalysisTabView} from 'molbio/crispr/CRISPRAnalysisTabView';
import HRTemplateTabState from 'molbio/crispr/hr-template/HRTemplateTabState';
import * as HRTemplateTabView from 'molbio/crispr/hr-template/HRTemplateTabView';
import {FindPrimersOptionsView} from 'molbio/find-primers/FindPrimersOptionsView';
import {FindPrimersTabState} from 'molbio/find-primers/FindPrimersTabState';
import FindPrimersView from 'molbio/find-primers/ReactFindPrimersTabView';
import ProteinAlignmentTabView from 'molbio/maps/alignment/AaSequenceAlignmentTabView';
import SequenceAlignmentTabView from 'molbio/maps/alignment/SequenceAlignmentTabView';
import {CircularMapTabView} from 'molbio/maps/circular/Circular';
import * as ProteinMapView from 'molbio/maps/linear/AaSequenceMapView';
import {SequenceLinearMapTabView} from 'molbio/maps/linear/Linear';
import {MiniMapTabView} from 'molbio/maps/linear/MiniMap';
import {CircularMapTabOptionsView} from 'molbio/maps/options/CircularSequenceOptionsView';
import {LinearMapTabOptionsView} from 'molbio/maps/options/LinearSequenceOptionsView';
import {MiniMapTabOptionsView} from 'molbio/maps/options/MiniMapSequenceOptionsView';
import NucleotidesTabState from 'molbio/monomers/NucleotidesTabState';
import NucleotidesTabView from 'molbio/monomers/NucleotidesTabView';
import ProteinAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';
import ProteinMapTabState from 'molbio/tabstates/AaSequenceMapTabState';
import CircularMapTabState from 'molbio/tabstates/CircularMapTabState';
import MiniMapTabState from 'molbio/tabstates/MiniMapTabState';
import OligoLinearMapTabState from 'molbio/tabstates/OligoLinearMapTabState';
import RNASequenceLinearMapTabState from 'molbio/tabstates/RNASequenceLinearMapTabState';
import RNASequenceMiniMapTabState from 'molbio/tabstates/RNASequenceMiniMapTabState';
import SequenceAlignmentTabState from 'molbio/tabstates/SequenceAlignmentTabState';
import SequenceLinearMapTabState from 'molbio/tabstates/SequenceLinearMapTabState';
import AssemblyHistoryTabState from 'molbio/visual-history/assembly-history/AssemblyHistoryTabState';
import AssemblyHistoryTabView from 'molbio/visual-history/assembly-history/AssemblyHistoryTabView';
import VisualHistoryTabState from 'molbio/visual-history/VisualHistoryTabState';
import VisualHistoryTabView from 'molbio/visual-history/VisualHistoryTabView';
import {TabState} from 'Navigation';
import * as BlobLinkTab from 'notebook/data-tables/BlobLinkTab';
import NoteLinkedEmbeddingTab from 'notebook/embeddings/NoteLinkedEmbeddingTab';
import {EmptyEntryTabState, EmptyEntryTabView} from 'notebook/entries/backbone/tabs/EmptyEntryTab';
import EntryProtocolTabState from 'notebook/entries/backbone/tabs/EntryProtocolTab';
import * as EntryProtocolView from 'notebook/entries/backbone/tabs/EntryProtocolView';
import {
  ExternalEntryProtocolOptionsView,
  ExternalEntryProtocolTabState,
  ExternalEntryProtocolTabView,
} from 'notebook/entries/backbone/tabs/ExternalEntryProtocol';
import {
  NewEntryProtocolTabState,
  NewEntryProtocolTabView,
} from 'notebook/entries/backbone/tabs/NewEntryProtocolTab';
import * as NoteLinkedFileTab from 'notebook/notes/attachments/NoteLinkedFileTab';
import NoteTabState from 'notebook/notes/tabs/NoteTabState';
// @ts-expect-error
import NoteTabView from 'notebook/notes/tabs/NoteTabView';
import ProtocolTabState from 'notebook/protocols/backbone/tabs/ProtocolTabState';
import * as ProtocolView from 'notebook/protocols/backbone/tabs/ProtocolTabView';
import ReviewHistoryTabState from 'notebook/reviews/ReviewHistoryTabState';
import ReviewHistoryTabView from 'notebook/reviews/ReviewHistoryTabView';
import ReviewTabState from 'notebook/reviews/ReviewTabState';
import {ReviewTabView} from 'notebook/reviews/ReviewView';
import WorksheetTabState from 'notebook/worksheets/workspace/WorksheetTabState';
import WorksheetTabView from 'notebook/worksheets/workspace/WorksheetTabView';
import ProcedureTabState from 'procedures/ProcedureTabState';
import ProcedureTabView from 'procedures/ProcedureTabView';
import ProcessDetailsTabState from 'processes/process-details/ProcessDetailsTabState';
import ProcessDetailsTabView from 'processes/process-details/ProcessDetailsTabView';
import ProcessFlowchartTabState from 'processes/process-details/ProcessFlowchartTabState';
import ProcessFlowchartTabView from 'processes/process-details/ProcessFlowchartTabView';
import ProcessTaskDetailsOutputsTabState from 'processes/process-task-details/ProcessTaskDetailsOutputsTabState';
import ProcessTaskDetailsOutputsTabView from 'processes/process-task-details/ProcessTaskDetailsOutputsTabView';
import ProcessTaskDetailsTabState from 'processes/process-task-details/ProcessTaskDetailsTabState';
import ProcessTaskDetailsTabView from 'processes/process-task-details/ProcessTaskDetailsTabView';
import ProcessTaskFlowchartTabState from 'processes/process-task-details/ProcessTaskFlowchartTabState';
import ProcessTaskFlowchartTabView from 'processes/process-task-details/ProcessTaskFlowchartTabView';
import RequestV2DefinitionTabState from 'processes/requests_v2/request-v2-definition/RequestV2DefinitionTabState';
import RequestV2DefinitionTabView from 'processes/requests_v2/request-v2-definition/RequestV2DefinitionTabView';
import RequestV2SubmissionDocumentTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocumentTabState';
import RequestV2SubmissionDocumentTabView from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocumentTabView';
import RequestV2SubmissionProgressAndOutputsTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputsTabState';
import RequestV2SubmissionProgressAndOutputsTabView from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputsTabView';
import ChildEntityTabState from 'registry/child-entities/ChildEntityTabState';
import ChildEntityTabView from 'registry/child-entities/ChildEntityTabView';
import EntityMapTabState from 'registry/entity-map/tab/EntityMapTabState';
import EntityMapTabView from 'registry/entity-map/tab/EntityMapTabView';
import RelevantItemsTabState from 'relevant-items/RelevantItemsTabState';
import RelevantItemsTabView from 'relevant-items/RelevantItemsTabView';
import RequestDetailsTabState from 'requests/request-view/RequestDetailsTabState';
import RequestDetailsTabView from 'requests/request-view/RequestDetailsTabView';
import RequestResponseTabState from 'requests/request-view/RequestResponseTabState';
import RequestResponseTabView from 'requests/request-view/RequestResponseTabView';
import EntityResultsTabState from 'results/linked-results/EntityResultsTabState';
import EntityResultsTabView from 'results/linked-results/EntityResultsTabView';
import LinkedResultsTabState from 'results/linked-results/LinkedResultsTabState';
import LinkedResultsTabView from 'results/linked-results/LinkedResultsTabView';
import StorableResultsTabState from 'results/linked-results/StorableResultsTabState';
import StorableResultsTabView from 'results/linked-results/StorableResultsTabView';
import ResultStatusTabState from 'results/validation/status-tab/ResultStatusTabState';
import {ResultStatusTabView} from 'results/validation/status-tab/ResultStatusTabView';
import RunDetailsTabState from 'runs/editor/RunDetailsTabState';
import RunDetailsTabView from 'runs/editor/RunDetailsTabView';
import RunResultsTabState from 'runs/editor/RunResultsTabState';
import RunResultsTabView from 'runs/editor/RunResultsTabView';
import ContainerTestOrdersTabState from 'sample-tests/ui/test-orders/ContainerTestOrdersTabState';
import ContainerTestOrdersTabView from 'sample-tests/ui/test-orders/ContainerTestOrdersTabView';
import EntityTestOrdersTabState from 'sample-tests/ui/test-orders/EntityTestOrdersTabState';
import EntityTestOrdersTabView from 'sample-tests/ui/test-orders/EntityTestOrdersTabView';
import ContainerTabState from 'samples/containers/ContainerTabState';
import ContainerTabView from 'samples/containers/ContainerTabView';
import BoxTabState from 'samples/grids/BoxTabState';
import GridContentsTabState from 'samples/grids/GridContentsTabState';
import GridContentsTabView from 'samples/grids/GridContentsTabView';
import GridMetadataTabState from 'samples/grids/GridMetadataTabState';
import GridMetadataTabView from 'samples/grids/GridMetadataTabView';
import GridTabView from 'samples/grids/GridTabView';
import PlateTabState from 'samples/grids/PlateTabState';
import LocationTabState from 'samples/locations/LocationTabState';
import LocationTabView from 'samples/locations/LocationTabView';
import StorageTabState from 'samples/StorageTabState';
import StorageTabView from 'samples/StorageTabView';
import StudyDesignTabState from 'studies/workspace/tabs/StudyDesignTabState';
import StudyDesignTabView from 'studies/workspace/tabs/StudyDesignTabView';
import StudyListingTabState from 'studies/workspace/tabs/StudyListingTabState';
import StudyListingTabView from 'studies/workspace/tabs/StudyListingTabView';
import StudyOverviewTabState from 'studies/workspace/tabs/StudyOverviewTabState';
import StudyOverviewTabView from 'studies/workspace/tabs/StudyOverviewTabView';
import VisualizationState from 'studies/workspace/tabs/VisualizationState';
import VisualizationView from 'studies/workspace/tabs/VisualizationView';

const TABSTATE_TO_VIEW: Array<BufferViewMetadata> = [
  {
    tabState: SequenceAlignmentTabState,
    tabViewMetadata: {TabView: SequenceAlignmentTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: SequenceAlignmentTabOptionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: AlphaFoldTabState,
    tabViewMetadata: {
      TabView: AlphaFoldTabView,
      tabViewType: BufferViewType.REACT,
      propsFromTabState: (tabState: AlphaFoldTabState): AlphaFoldTabContentProps => {
        const initialView = tabState.get('initialView');
        if (initialView != null) {
          return {
            proteinId: tabState.protein().id,
            initialView,
            clearInitialView: () => tabState.unset('initialView'),
          };
        }
        return {proteinId: tabState.protein().id};
      },
      additionalTabClassNames: 'buffer-tab--no-padding',
    },
    optionsViewMetadata: {
      OptionsView: AlphaFoldOptionsView,
      optionsViewType: BufferViewType.REACT,
      propsFromTabState: (tabState: AlphaFoldTabState): AlphaFoldOptionsProps => ({
        proteinId: tabState.protein().id,
      }),
    },
    dataTestAttrs: {component: 'ProteinStructureTab', element: 'root'},
  },
  {
    tabState: AnalysisTabState,
    tabViewMetadata: {TabView: AnalysisTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: AnalysisTemplateTabState,
    tabViewMetadata: {TabView: AnalysisTemplateTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: AnalyticsDashboardTabState,
    tabViewMetadata: {TabView: AnalyticsDashboardTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: AnnotationsTableTabState,
    tabViewMetadata: {TabView: AnnotationsTableTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: AntibodyMapTabState,
    tabViewMetadata: {TabView: AntibodyMapTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: AntibodyMapTabOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: AssemblyHistoryTabState,
    tabViewMetadata: {TabView: AssemblyHistoryTabView, tabViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'AssemblyHistoryTab', element: 'root'},
  },
  {
    tabState: BenchlingAppTabState,
    tabViewMetadata: {TabView: BenchlingAppTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: TranslationBiochemicalPropertiesTabState,
    tabViewMetadata: {TabView: BiochemicalPropertiesTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProteinBiochemicalPropertiesTabState,
    tabViewMetadata: {TabView: BiochemicalPropertiesTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: BlobLinkTab.tabState,
    tabViewMetadata: {TabView: BlobLinkTab.tabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: BlobLinkTab.optionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: BoxTabState,
    tabViewMetadata: {TabView: GridTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: BulkAssemblyConstructsTabState,
    tabViewMetadata: {TabView: BulkAssemblyConstructsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: BulkAssemblyFragmentsTabState,
    tabViewMetadata: {TabView: BulkAssemblyFragmentsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: BulkAssemblyOverviewTabState,
    tabViewMetadata: {TabView: BulkAssemblyOverviewTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ChildEntityTabState,
    tabViewMetadata: {TabView: ChildEntityTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: CircularMapTabState,
    tabViewMetadata: {TabView: CircularMapTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: CircularMapTabOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: CodonOptimizationTabState,
    tabViewMetadata: {TabView: CodonOptimizationTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ComplexPolymerMapTabState,
    tabViewMetadata: {TabView: ComplexPolymerMapTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ComplexPolymerComponentsTabState,
    tabViewMetadata: {TabView: ComplexPolymerComponentsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ConnectionDataTabState,
    tabViewMetadata: {TabView: ConnectionDataTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ConnectionDetailsTabState,
    tabViewMetadata: {TabView: ConnectionDetailsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ConnectionRunsTabState,
    tabViewMetadata: {TabView: ConnectionRunsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ContainerTabState,
    tabViewMetadata: {TabView: ContainerTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: CRISPRAnalysisTabState,
    tabViewMetadata: {TabView: CRISPRAnalysisTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: CRISPRAnalysisOptionsView, optionsViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'DesignCRISPRTab', element: 'root'},
  },
  {
    tabState: CRISPRAssemblyTabState,
    tabViewMetadata: {TabView: CRISPRAssemblyTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: CRISPRAssemblyOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: DatasetTabState,
    tabViewMetadata: {TabView: DatasetTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: DigestTabState,
    tabViewMetadata: {TabView: DigestView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: DigestView.OptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: EditPrimerTabState,
    tabViewMetadata: {TabView: EditPrimerView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: EditPrimerView.OptionsView, optionsViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'EditPrimerTab', element: 'root'},
  },
  {
    tabState: EmbeddedAnalyticsDashboardTabState,
    tabViewMetadata: {TabView: EmbeddedAnalyticsDashboardTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: EmptyEntryTabState,
    tabViewMetadata: {TabView: EmptyEntryTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: EntityResultsTabState,
    tabViewMetadata: {TabView: EntityResultsTabView, tabViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'EntityResultsTab', element: 'root'},
  },
  {
    tabState: EntityMapTabState,
    tabViewMetadata: {TabView: EntityMapTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: EntryProtocolTabState,
    tabViewMetadata: {TabView: EntryProtocolView.TabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ExternalEntryProtocolTabState,
    tabViewMetadata: {TabView: ExternalEntryProtocolTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: ExternalEntryProtocolOptionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: ExternalFileTabState,
    tabViewMetadata: {TabView: ExternalFileTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: ExternalFileOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: FileTabState,
    tabViewMetadata: {TabView: FileTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: FindPrimersTabState,
    tabViewMetadata: {TabView: FindPrimersView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: FindPrimersOptionsView, optionsViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'FindPrimersTab', element: 'root'},
  },
  {
    tabState: FormDefinitionTabState,
    tabViewMetadata: {TabView: FormDefinitionTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: GenerativeModelsTabState,
    tabViewMetadata: {TabView: GenerativeModelsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: GibsonTabState,
    tabViewMetadata: {TabView: GibsonTabView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: GibsonTabView.OptionsView, optionsViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'GibsonAssemblyTab', element: 'root'},
  },
  {
    tabState: GoldenGateTabState,
    tabViewMetadata: {TabView: GoldenGateTabView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: GoldenGateTabView.OptionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: GridContentsTabState,
    tabViewMetadata: {TabView: GridContentsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: GridMetadataTabState,
    tabViewMetadata: {TabView: GridMetadataTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: HRTemplateTabState,
    tabViewMetadata: {TabView: HRTemplateTabView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: HRTemplateTabView.OptionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: JellyfishTabState,
    tabViewMetadata: {TabView: JellyfishTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: LocationTabState,
    tabViewMetadata: {TabView: LocationTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: MetadataTabState,
    tabViewMetadata: {TabView: MetadataTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: MiniMapTabState,
    tabViewMetadata: {TabView: MiniMapTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: MiniMapTabOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: MoleculeChemicalStructureTabState,
    tabViewMetadata: {TabView: MoleculeChemicalStructureTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: MoleculePhysicochemicalPropertiesTabState,
    tabViewMetadata: {
      TabView: MoleculePhysicochemicalPropertiesTabView,
      tabViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: NewEntryProtocolTabState,
    tabViewMetadata: {TabView: NewEntryProtocolTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: NoteLinkedEmbeddingTab.tabState,
    tabViewMetadata: {TabView: NoteLinkedEmbeddingTab.tabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: NoteLinkedFileTab.tabState,
    tabViewMetadata: {TabView: NoteLinkedFileTab.tabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: NoteLinkedFileTab.optionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: NoteTabState,
    tabViewMetadata: {TabView: NoteTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: NucleotidesTabState,
    tabViewMetadata: {TabView: NucleotidesTabView, tabViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'NucleotidesTab', element: 'root'},
  },
  {
    tabState: OligoLinearMapTabState,
    tabViewMetadata: {TabView: SequenceLinearMapTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: LinearMapTabOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: PlateTabState,
    tabViewMetadata: {TabView: GridTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: Primer3TabState,
    tabViewMetadata: {TabView: Primer3View.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: Primer3View.OptionsView, optionsViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'Primer3ResultsTab', element: 'root'},
  },
  {
    tabState: PrimerWizardTabState,
    tabViewMetadata: {TabView: PrimerWizardTab.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: PrimerWizardTab.OptionsView, optionsViewType: BufferViewType.BACKBONE},
    dataTestAttrs: {component: 'PrimerWizardTab', element: 'root'},
  },
  {
    tabState: ProcedureTabState,
    tabViewMetadata: {TabView: ProcedureTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProcessDetailsTabState,
    tabViewMetadata: {TabView: ProcessDetailsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProcessFlowchartTabState,
    tabViewMetadata: {TabView: ProcessFlowchartTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProcessTaskDetailsOutputsTabState,
    tabViewMetadata: {TabView: ProcessTaskDetailsOutputsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProcessTaskDetailsTabState,
    tabViewMetadata: {TabView: ProcessTaskDetailsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProcessTaskFlowchartTabState,
    tabViewMetadata: {TabView: ProcessTaskFlowchartTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProteinAlignmentTabState,
    tabViewMetadata: {TabView: ProteinAlignmentTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: ProteinAlignmentTabOptionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: ProteinComplexPreviewTab.tabState,
    tabViewMetadata: {TabView: ProteinComplexPreviewTab.tabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProteinComplexPropertiesTab.tabState,
    tabViewMetadata: {TabView: ProteinComplexPropertiesTab.tabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProteinMapTabState,
    tabViewMetadata: {TabView: ProteinMapView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: ProteinMapView.OptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ProtocolTabState,
    tabViewMetadata: {TabView: ProtocolView.TabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RelevantItemsTabState,
    tabViewMetadata: {TabView: RelevantItemsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RequestDetailsTabState,
    tabViewMetadata: {TabView: RequestDetailsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RequestResponseTabState,
    tabViewMetadata: {TabView: RequestResponseTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RequestV2DefinitionTabState,
    tabViewMetadata: {TabView: RequestV2DefinitionTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RequestV2SubmissionDocumentTabState,
    tabViewMetadata: {TabView: RequestV2SubmissionDocumentTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RequestV2SubmissionProgressAndOutputsTabState,
    tabViewMetadata: {
      TabView: RequestV2SubmissionProgressAndOutputsTabView,
      tabViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: ResultStatusTabState,
    tabViewMetadata: {TabView: ResultStatusTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ReviewTabState,
    tabViewMetadata: {TabView: ReviewTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ReviewHistoryTabState,
    tabViewMetadata: {TabView: ReviewHistoryTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RNASequenceLinearMapTabState,
    tabViewMetadata: {TabView: SequenceLinearMapTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: LinearMapTabOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RNASequenceMiniMapTabState,
    tabViewMetadata: {TabView: MiniMapTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: MiniMapTabOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RunDetailsTabState,
    tabViewMetadata: {TabView: RunDetailsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: RunResultsTabState,
    tabViewMetadata: {TabView: RunResultsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: SecondaryStructureTabState,
    tabViewMetadata: {TabView: SecondaryStructureView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: SecondaryStructureView.OptionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: SequenceLinearMapTabState,
    tabViewMetadata: {TabView: SequenceLinearMapTabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {OptionsView: LinearMapTabOptionsView, optionsViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: StorableResultsTabState,
    tabViewMetadata: {TabView: StorableResultsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: StorageTabState,
    tabViewMetadata: {TabView: StorageTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: LinkedResultsTabState,
    tabViewMetadata: {TabView: LinkedResultsTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: StudyListingTabState,
    tabViewMetadata: {TabView: StudyListingTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: StudyDesignTabState,
    tabViewMetadata: {TabView: StudyDesignTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: StudyOverviewTabState,
    tabViewMetadata: {TabView: StudyOverviewTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: VisualizationState,
    tabViewMetadata: {TabView: VisualizationView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: EntityTestOrdersTabState,
    tabViewMetadata: {TabView: EntityTestOrdersTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: ContainerTestOrdersTabState,
    tabViewMetadata: {TabView: ContainerTestOrdersTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: TranslationTabState,
    tabViewMetadata: {TabView: TranslationTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: VirtualDigestTabState,
    tabViewMetadata: {TabView: VirtualDigestView.TabView, tabViewType: BufferViewType.BACKBONE},
    optionsViewMetadata: {
      OptionsView: VirtualDigestView.OptionsView,
      optionsViewType: BufferViewType.BACKBONE,
    },
  },
  {
    tabState: VisualHistoryTabState,
    tabViewMetadata: {TabView: VisualHistoryTabView, tabViewType: BufferViewType.BACKBONE},
  },
  {
    tabState: WorksheetTabState,
    tabViewMetadata: {TabView: WorksheetTabView, tabViewType: BufferViewType.BACKBONE},
  },
];

function getView(tabstate: TabState): Omit<BufferViewMetadata, 'tabState'> {
  for (const obj of TABSTATE_TO_VIEW) {
    if (tabstate instanceof obj.tabState) {
      return {
        tabViewMetadata: obj.tabViewMetadata,
        optionsViewMetadata: obj.optionsViewMetadata,
        dataTestAttrs: obj.dataTestAttrs,
      };
    }
  }
  throw new Error(`Unexpected tab state: ${tabstate.constructor.name}, please add it in buffers view`);
}

export {TABSTATE_TO_VIEW as __TABSTATE_TO_VIEW, getView};
